import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
// require('dotenv');

// const ApiService: string =
//   process.env.NEXT_PUBLIC_API_URL ?? 'https://core-dev.cruncher.systems';
// const ApiServiceFE: string =
//   process.env.NEXT_PUBLIC_WEB_API_FE_URL ?? 'https://app2-dev.cruncher.systems';
// const RealtimeService: string =
//   process.env.NEXT_PUBLIC_SOCKET_URL ?? 'https://realtime-dev.cruncher.systems';

const ApiService: string =
  process.env.NEXT_PUBLIC_API_URL ?? 'APP_NEXT_PUBLIC_API_URL';
const ApiServiceFE: string =
  process.env.NEXT_PUBLIC_WEB_API_FE_URL ?? 'APP_NEXT_PUBLIC_WEB_API_FE_URL';
// window.location.origin;
const RealtimeService: string =
  process.env.NEXT_PUBLIC_SOCKET_URL ?? 'APP_NEXT_PUBLIC_SOCKET_URL';

const RealtimeConvertFileService: string =
  process.env.NEXT_PUBLIC_SOCKET_CONVERT_FILE_URL ??
  'NEXT_PUBLIC_SOCKET_CONVERT_FILE_URL';

const UPLOAD_URL: string =
  process.env.NEXT_PUBLIC_STORAGE_URL ?? 'NEXT_PUBLIC_STORAGE_URL';

const TimeCookie: number = 3600;
const BrandX: string = 'x-brand-id';

const initialEnv = {
  ApiService,
  ApiServiceFE,
  RealtimeService,
  RealtimeConvertFileService,
  BrandX,
  TimeCookie,
  UPLOAD_URL,
};

const envSchema = Type.Object({
  ApiService: Type.String(),
  ApiServiceFE: Type.String(),
  RealtimeService: Type.String(),
  RealtimeConvertFileService: Type.String(),
  TimeCookie: Type.Number(),
  BrandX: Type.String(),
  UPLOAD_URL: Type.String(),
});

if (!Value.Check(envSchema, initialEnv))
  throw new Error('Invalid env variables');
export const env = Value.Cast(envSchema, initialEnv);

export { ApiService, RealtimeService, RealtimeConvertFileService };
